// Configuration Firebase en JavaScript pur pour éviter les problèmes TypeScript
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
// Temporairement désactivé pour déboguer l'erreur "cancelled"
// import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
let initializeAppCheck, ReCaptchaV3Provider;

const firebaseConfig = {
  apiKey: "AIzaSyA9yWoep0xsC-W8w0lBffUOyWFBsh_lCvI",
  authDomain: "hubexport-35b07.firebaseapp.com",
  projectId: "hubexport-35b07",
  storageBucket: "hubexport-35b07.firebasestorage.app",
  messagingSenderId: "1017602750018",
  appId: "1:1017602750018:web:4b121f899c7374f5b69fdb",
  measurementId: "G-7MK5JX8HEM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

// Initialize App Check avec reCAPTCHA v3
// Note: Configurez REACT_APP_RECAPTCHA_SITE_KEY dans votre fichier .env
// En développement, vous pouvez utiliser un token de debug depuis la console Firebase
// Pour désactiver App Check temporairement, ajoutez REACT_APP_APP_CHECK_ENABLED=false dans .env
let appCheck = undefined;
const appCheckEnabled = process.env.REACT_APP_APP_CHECK_ENABLED !== 'false';

// Ne pas initialiser App Check si désactivé explicitement ou si les modules ne sont pas disponibles
if (!appCheckEnabled || !initializeAppCheck || !ReCaptchaV3Provider) {
  console.log('ℹ️ App Check désactivé');
  appCheck = undefined;
} else {
  try {
    const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (recaptchaSiteKey && recaptchaSiteKey !== 'votre_site_key_ici') {
      // Initialiser App Check de manière synchrone mais avec gestion d'erreur robuste
      // Wrapper dans un try-catch pour éviter toute erreur non gérée
      try {
        appCheck = initializeAppCheck(app, {
          provider: new ReCaptchaV3Provider(recaptchaSiteKey),
          isTokenAutoRefreshEnabled: true
        });
        console.log('✅ App Check initialisé avec reCAPTCHA v3');
      } catch (initError) {
        // Erreur lors de l'initialisation, ne pas bloquer
        console.warn('⚠️ Erreur lors de l\'initialisation d\'App Check:', initError?.message || initError);
        appCheck = undefined;
      }
    } else {
      console.warn('⚠️ REACT_APP_RECAPTCHA_SITE_KEY non configuré. App Check désactivé.');
      appCheck = undefined;
    }
  } catch (error) {
    // Ne pas bloquer l'application si App Check échoue à l'initialisation
    console.warn('⚠️ Erreur lors de la configuration d\'App Check (non bloquant):', error?.message || error);
    appCheck = undefined;
  }
}

/**
 * Fonction helper pour obtenir l'instance App Check
 * Utile pour TypeScript qui ne peut pas inférer le type depuis un fichier JS
 */
export const getAppCheckInstance = () => {
  return appCheck;
};

export { app, auth, analytics, appCheck };
